import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Progress, Button} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import Tooltip from '../../../Shared/Tooltip/Tooltip';
import {dataUsageWarningTooltipData} from '../productsAndServicesBlockSlice';

export function ColumnHtml(props) {
  return (
    <div className={` d-flex column  ${props.customClass || ''}`} style={{width: `${props.columnWidth}%`}}>
      {props.item}
      {props.children && props.children}
    </div>
  );
}

export function ColumnTwoPartsHtml(props) {
  return (
    <div
      className={`${props.customClass || ''} column_two_parts`}
      style={{width: `${props.columnWidth ? props.columnWidth + '%' : '100%'}`}}>
      <div
        className={`blackShadeColor d-flex ${props.titleCustomClass || ''}`}
        style={{width: `${props.titleWidth ? props.titleWidth + '%' : '50%'}`}}>
        {props.title || ''}
      </div>
      <div className={`pr-1 d-flex ${props.textCustomClass || ''}`} style={{width: `${props.textWidth ? props.textWidth + '%' : '50%'}`}}>
        {props.text ? props.text : ''}
        {props.children && props.children}
      </div>
    </div>
  );
}

export function ColumnHtmlWithIcon(props) {
  if(props.item!=null){
  const buildTitle = () => {
    let lastIndex = props.item?.lastIndexOf(' ');
    let str = props.item?.substring(0, lastIndex);
    return str;
  };
  return (
    <div className='column_with_icon d-flex' style={{width: `${props.columnWidth + '%' || '100%'}`}}>
      <div>
        <span className={` ${!isMobile ? ' align-items-center' : ''}`}>{buildTitle()} &nbsp;</span>
        <span className={` ${!isMobile ? ' align-items-center' : ''} text-nowrap`}>
          {props.item?.split(' ').pop()}
          <Button color='link' className={` pointer ${!isMobile ? ' align-items-center' : ' pt-0'}`} onClick={() => props.buttonAction()}>
            <Image src={require('../images/info.svg')} alt='start' />
          </Button>
        </span>
      </div>
    </div>
  );
  }
  return <div></div>
}

export function DataUsageHtml(props) {
  const balanceIsEqualsUsed =
    props.item?.dataUsage && props.item?.isSameUnitDataUsage && props.item.dataUsage.used == props.item?.dataUsage.quantity;
  return (
    <div
      className={`productsAndServices_dataUsage ${!isMobile ? 'd-flex' : ''} ${props.customClass || ''}`}
      style={{width: `${props.columnWidth + '%' || '100%'}`}}>
      {props.item?.isBlocked === false && props.item?.dataUsage ? (
        <>
          {props.item.isUnlimited === false ? (
            <>
              <div className='capacity d-flex'>
                <div className='semiBold'>
                  {props.item.dataUsage.quantity}
                  {props.item.dataUsage.quantityUnitOfMeasure}
                </div>
                /
                <div className={`used cellcomColor semiBold ${balanceIsEqualsUsed ? 'warning' : ''}`}>
                  {props.item.dataUsage.used}
                  {props.item.dataUsage.usedUnitOfMeasure}
                </div>
                {isMobile && balanceIsEqualsUsed && (
                  <div onClick={() => props.alertAction()} className='pl-2 pr-1 pointer warning-icon' id={`warning-${props.index}`}>
                    <Image src={require('../images/alert.svg')} alt='alert' />
                  </div>
                )}
              </div>
              <div className={`status-bar-bg ${balanceIsEqualsUsed ? 'warning' : ''}`}>
                <Progress value={props.item.dataUsage.statusBarWidth} />
              </div>
              {!isMobile && balanceIsEqualsUsed && (
                <div className='pl-2 pr-2 pointer warning-icon' id={`warning-${props.index}`}>
                  <Image src={require('../images/alert.svg')} alt='alert' />
                </div>
              )}
              {balanceIsEqualsUsed && (
                <Tooltip
                  title={dataUsageWarningTooltipData.title}
                  text={dataUsageWarningTooltipData.text}
                  target={`warning-${props.index}`}
                  placement={'top'}
                  cellcomdefault={true}
                />
              )}
            </>
          ) : (
            <div className={`unlimited ${!isMobile ? 'd-flex' : ''}`}>
              גלשת
              <span className='primary pr-1 pl-1 semiBold'>
                {props.item.dataUsage.used}
                {props.item.dataUsage.usedUnitOfMeasure}
              </span>
              מתוך חבילת הגלישה שלך
            </div>
          )}
          {props.buttonAction && (
            <div className='usage-info-button'>
              <Button color='link' className='underline' onClick={() => props.buttonAction()}>
                מידע על הגלישה שלי
              </Button>
            </div>
          )}
        </>
      ) : (
        <div className='no-data'>במנוי זה לא נמצאו שימושי גלישת סלולר להצגה</div>
      )}
    </div>
  );
}
